import { useState } from 'react';
import { useLocation } from 'react-router';
import { useFrame } from '@/app/frame';
import { HeaderButton } from '@/ui/primitives';
import { Menu, MenuContent, MenuItem } from '@/ui/menu';
import { CreateRecord } from './CreateRecord';
import { NewTask } from '@/tasks/Assign';

export function ManualAdd({ wide }: { wide: boolean }) {
  const frame = useFrame();
  const location = useLocation();
  const [form, setForm] = useState<'company' | 'contact' | 'task' | null>(null);
  const match = /^\/companies\/([0-9a-f-]{36})$/i.exec(location.pathname);
  const companyId = match?.[1];
  return <>
    <Menu.Root modal={false}>
      <Menu.Trigger asChild><HeaderButton label="Add company, contact or task" glyph="add" word={wide && 'Add'} /></Menu.Trigger>
      <MenuContent aria-label="Add" className="w-[min(280px,calc(100vw-32px))]">
        <MenuItem onSelect={() => setForm('company')}>Company</MenuItem>
        <MenuItem onSelect={() => setForm('contact')}>Contact</MenuItem>
        <MenuItem onSelect={() => setForm('task')}>Task</MenuItem>
        <MenuItem last onSelect={() => frame.ask('Help me arrange my tasks into a plan: ')}>Ask my twin</MenuItem>
      </MenuContent>
    </Menu.Root>
    {(form === 'company' || form === 'contact') && <CreateRecord kind={form} {...(companyId ? { companyId } : {})} onClose={() => setForm(null)} />}
    {form === 'task' && <NewTask stay onClose={() => setForm(null)} {...(companyId ? { initialCompanyId: companyId } : {})} />}
  </>;
}
